import { render } from "./ModalDocumentUploadProgress.vue?vue&type=template&id=4e095a98&scoped=true"
import script from "./ModalDocumentUploadProgress.vue?vue&type=script&lang=js"
export * from "./ModalDocumentUploadProgress.vue?vue&type=script&lang=js"

import "./ModalDocumentUploadProgress.vue?vue&type=style&index=0&id=4e095a98&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e095a98"]])

export default __exports__